<template>
  <div v-show="showPropertiesBlock" class="bg-white">
    <div class="container mx-auto py-10">
      <div class="mt-5">
        <ProductTitledBlock v-if="showPropertiesBlock" title="" image-src="" icon="">
          <VcTypography tag="h2" class="mb-4">{{
            $t("shared.catalog.product_details.technical_specs_block_title")
          }}</VcTypography>
          <VcCollapsibleContent max-height="19rem" col-split>
            <ProductProperty v-for="property in properties" :key="property.name" :label="property.label!" class="mb-4">
              <template v-if="isExternalUrl(property.value as string)">
                <a target="_blank" :href="property.value as string">{{ property.value }}</a>
              </template>
              <template v-else>
                {{ property.value }}
              </template>
            </ProductProperty>

            <!-- Vendor -->
            <ProductProperty
              v-if="showVendor && $cfg.vendor_enabled"
              :label="$t('shared.catalog.product_details.vendor_label')"
              class="mb-4"
            >
              <Vendor :vendor="product.vendor!" with-rating />
            </ProductProperty>
          </VcCollapsibleContent>
          <!-- Properties -->
        </ProductTitledBlock>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { computed } from "vue";
import { PropertyType } from "@/core/api/graphql/types";
import { INNO_HIDE_PROPERTIES } from "@/core/constants";
import { getPropertiesGroupedByName, isExternalUrl } from "@/core/utilities";
import { ProductProperty, ProductTitledBlock, Vendor } from "@/shared/catalog";
import type { Product } from "@/core/api/graphql/types";

interface IProps {
  product: Product;
  model: {
    title?: string;
    hidden?: boolean;
  };
}

const props = defineProps<IProps>();

const twoBaProperties = computed<string | undefined>(
  () => props.product.descriptions.filter((desc) => desc.reviewType == "Properties")[0]?.content ?? undefined,
);

// Custom Innovadis. These properties are from SalesLayer

let transformedDataArray: any = [];

interface CustomProperty {
  id: string;
  Label: string;
  Value: string;
  Unit: string;
  Priority: string;
  Hidden: boolean;
}

if (twoBaProperties.value) {
  const parsedData = JSON.parse(twoBaProperties.value);
  const dataArray: Array<CustomProperty[]> = Object.values(parsedData);

  transformedDataArray = dataArray.map((item: any) => ({
    id: item.Id,
    label: item.Label,
    value: item.Value,
    unit: item.Unit,
    priority: item.Priority,
    hidden: false,
  }));
}

const properties = computed(() =>
  Object.values(
    getPropertiesGroupedByName(
      props.product?.properties?.filter((prop) => !INNO_HIDE_PROPERTIES.includes(prop.name)) ?? [],
      PropertyType.Variation,
    ),
  )
    .concat(transformedDataArray)
    .sort((a, b) => a.label.localeCompare(b.label)),
);

const showVendor = computed(() => !props.product.hasVariations && props.product.vendor);
const showPropertiesBlock = computed(() => !props.model.hidden && (properties.value.length || showVendor.value));
</script>
